<div class="topbar">
  <div class="topbar-menu" (click)="menuClick()"><span class="fa-solid fa-bars isg-hamburger"></span></div>
  <div class="topbar-image">
    <img class="topbar-logo" src="assets/images/logos/logo-probechmark-white.png" alt="The ISG Logo in white" (click)="navHome()" />

  </div>
  <div class="topbar-impersonate">
    <app-impersonation-current (impersonateChanged)="onImpersonateChanged($event)">
    </app-impersonation-current> 
  </div>
  <div class="topbar-help">
    <!--  <app-apps-card></app-apps-card> -->
    <app-help-card></app-help-card>
  </div>
  <div class="topbar-admin"
      [ngClass]="{'isg-hidden': !(currentUser)}">
    <app-admin-card #adminMenu></app-admin-card>
  </div>
  <div class="topbar-user"
       [ngClass]="{'isg-hidden': !(currentUser)}">
    <app-user-card #userMenu></app-user-card>
  </div>
</div>
